import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
  setAddTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import Select, { MultiValue } from "react-select";
import {
  duration,
  languageOptions,
  optionindustry,
  optionsource,
  optionssymbol,
  owner,
  priorityList,
  project,
  ratingOptions,
  salestypelist,
  socialMedia,
  status,
  statusOption,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import CollapseHeader from "../../../core/common/collapse-header";
import Table from "../../../core/common/dataTable/index";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { companiesData } from "../../../core/data/json/companiesData";
import { TagsInput } from "react-tag-input-component";
import { Button, Form, Modal } from "react-bootstrap";
import { addCompany, changeOwner, deleteCompany, getAccessibilityForAccount, getAllCompanies, getCompanies, getCompanyDetail, updateAccessibilityForAccount, updateCompany } from "./companyAPI";
import { getAllTags } from "../deals/dealsAPI";
import { listLeadsOption, userList } from "../leads/logcall_api";
import { Pagination } from "antd";
import ResponseModal from "../../../core/modals/response_modal";
import { getTagList } from "../tags/tagAPI";
import { userListByRole } from "../users/userAPI";

interface Account {
  accountId: number;
  accountUuid: string;
  name: string;
  phone: string;
  tags: string[] | null;
  location: string;
  rating: number;
  ownerName: string;
  ownerUuid: string;
  facebook: string;
  twitter: string;
  linkedin: string;
  instagram: string;
  skype: string;
  whatsapp: string;
  status: "ACTIVE" | "INACTIVE" | null;
}

interface FilterParams {
  property: string;
  direction: "ASC" | "DESC";
  country: string;
  owner: string[];
  startRating: number | null;
  endRating: number | null;
  tagIds: string;
}

interface CompanyData {
  id: number;
  name: string;
  industry: string;
  email: string;
  phone: string;
  website: string;
  rating: number;
  owner: string;
  source: string;
  language: string;
  description: string;
  noOfEmployees: number;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  facebookLink: string | null;
  skypeLink: string | null;
  twitterLink: string | null;
  linkedinLink: string | null;
  instagramLink: string | null;
  whatsappLink: string | null;
  status: string;
  tags: Tag[];
}

interface Tag {
  tagId: number;
  name: string;
}

interface ContactInformation {
  CompanyId: number;
  name: string;
  phone: string;
  industry: string;
  description: string | null;
  noOfEmployees: number;
  ownerName: string;
  ownerUuid: string;
  language: string;
  rating: number;
  status: "ACTIVE" | "INACTIVE";
  facebookLink: string | null;
  skypeLink: string | null;
  linkedinLink: string | null;
  whatsappLink: string | null;
  instagramLink: string | null;
  twitterLink: string | null;
  country: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  public: boolean;
}

interface Opportunity {
  opportunityId: number;
  opportunityName: string;
  stage: string | null;
  amount: number;
  CompanyId: number;
  CompanyName: string;
  owner: string;
}

interface Tag {
  tagId: number;
  name: string;
}

interface CompanyDetail {
  contactInformation: ContactInformation;
  opportunities: Opportunity[];
  tagList: Tag[];
}

interface Lead {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
}

interface TagOption {
  value: number;
  label: string;
}
interface User {
  id: number;
  username: string;
  uuid: string;
  role: string;
}
const Companies = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [owner, setOwner] = useState(["Collab"]);
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);

  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const rowSelection = {
    selectedRowKeys: selectedRecordIds,
    onChange: (selectedKeys: any[]) => {
      setSelectedRecordIds(selectedKeys);
    },
  };
  const [deleteCompanyId, setDeleteCompanyId] = useState<number | null>(null);
  const [companyDetail, setCompanyDetail] = useState<CompanyDetail>({
    contactInformation: {
      CompanyId: 0,
      name: "",
      phone: "",
      industry: "",
      description: null,
      noOfEmployees: 0,
      ownerName: "",
      ownerUuid: "",
      language: "",
      rating: 0,
      status: "ACTIVE",
      facebookLink: null,
      skypeLink: null,
      linkedinLink: null,
      whatsappLink: null,
      instagramLink: null,
      twitterLink: null,
      country: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      createdAt: "",
      updatedAt: "",
      createdBy: "",
      updatedBy: "",
      public: true,
    },
    opportunities: [],
    tagList: [],
  });
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  useEffect(() => {
    fetchTags();
    fetchUserByRole();
  }, []);

  const [companyData, setCompanyData] = useState<CompanyData>({
    id: 0,
    name: "",
    industry: "",
    email: "",
    phone: "",
    website: "",
    rating: 0,
    owner: localStorage.getItem("userUuid") || "",
    source: "",
    language: "",
    description: "",
    noOfEmployees: 0,
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    facebookLink: "",
    skypeLink: "",
    twitterLink: "",
    linkedinLink: "",
    instagramLink: "",
    whatsappLink: "",
    status: "ACTIVE",
    tags: [],
  });


  const handleDeleteCompany = async () => {
    try {
      if (!deleteCompanyId) return;
      await deleteCompany(deleteCompanyId);
      setResponse({ status: "success", message: "Company deleted successfully!" });
      fetchData();
    } catch (error) {
      console.error("Error deleting company:", error);
      setResponse({ status: "error", message: "Failed to delete company. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name === "noOfEmployees") {
      const numericValue = value.replace(/,/g, "");

      if (!/^\d*$/.test(numericValue)) return;

      const parsedValue = parseInt(numericValue || "0", 10);

      setCompanyData(prevState => ({
        ...prevState,
        [name]: parsedValue,
      }));

      return;
    }

    setCompanyData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSelectChange = (
    selectedOption: { value: string; label: string } | null,
    field: string
  ) => {
    setCompanyData((prevData) => ({
      ...prevData,
      [field]: selectedOption ? selectedOption.value : "",
    }));
  };

  const [users, setUsers] = useState<User[]>([]);
  const fetchOwners = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userList(userTenantId);
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
      const owners = fetchedUsers.map((user: User) => ({
        value: user.uuid,
        label: user.username,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };
  useEffect(() => {
    fetchOwners();
  }, []);
  const fetchUserByRole = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userListByRole(userTenantId, "ACCOUNT_EXECUTIVE	");
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  const navigate = useNavigate();
  const [errorsAddForm, setErrorsAddForm] = useState<Record<string, string>>({});

  const validateAddForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (typeof value === "string" && value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => /^0\d{9,10}$/.test(value);

    const isValidEmail = (email: string) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!companyData.name.trim()) newErrors.name = "Name is required.";
    if (!companyData.website.trim()) newErrors.website = "Website is required.";
    if (!companyData.email.trim()) newErrors.email = "Email is required.";
    else if (!isValidEmail(companyData.email)) newErrors.email = "Invalid email format.";

    if (!companyData.phone.trim()) {
      newErrors.phone = "Phone is required.";
    } else if (!isValidPhone(companyData.phone)) {
      newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";
    }

    if (!companyData.owner.trim()) newErrors.owner = "Owner is required.";

    const fieldsMax50 = [
      "name", "industry", "email", "website", "owner", "source", "language",
      "facebookLink", "skypeLink", "linkedinLink", "twitterLink",
      "whatsappLink", "instagramLink", "street", "city", "state", "country"
    ];

    fieldsMax50.forEach((field) => {
      const value = (companyData as any)[field];
      if (value) isTooLong(value, field);
    });

    if (companyData.description && companyData.description.length > 256) {
      newErrors.description = "Description must not exceed 256 characters.";
    }

    if (companyData.zip) {
      if (!onlyDigits(companyData.zip) || companyData.zip.length !== 6) {
        newErrors.zip = "ZIP must be 6 digits and contain digits only.";
      }
    }

    if (
      companyData.noOfEmployees &&
      (!onlyDigits(companyData.noOfEmployees.toString()) ||
        Number(companyData.noOfEmployees) >= 1000000)
    ) {
      newErrors.noOfEmployees = "Number of Employees must be a number less than 1,000,000.";
    }

    setErrorsAddForm(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [createdId, setCreatedId] = useState(null);
  const handleAddCompany = async () => {
    try {
      const response = await addCompany(companyData);
      if (response.status === 200) {
        const newCompanyId = response.data.data;
        setCreatedId(newCompanyId);
        console.log("API", response);
        setOpenModal(true);
        fetchData();
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Add failed" });
        setShowMessageModal(true);
      }
    }
  };

  const [editCompanyId, setEditCompanyId] = useState<number | null>(null);

  const [filters, setFilters] = useState<FilterParams>({
    property: "name",
    direction: "ASC",
    country: "",
    owner: [],
    startRating: null,
    endRating: null,
    tagIds: "",
  });

  const initialFilterState: FilterParams = {
    property: "name",
    direction: "ASC",
    country: "",
    owner: [],
    startRating: null,
    endRating: null,
    tagIds: "",
  };

  const [sort, setSort] = useState({ field: "createdDate", order: "ASC" });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  type OptionType = { value: string; label: string };
  const handleOwnerChange = (selectedOptions: MultiValue<OptionType>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      owner: selectedOptions.map((option) => option.value),
    }));
  };

  const handlePageChange = (page: number) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageNo: page,
    }));
  };
  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setCompanyData(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        tags: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : [],
        id: prev.id ?? 0,
      };
    });
  };
  const handleDateChange = (date: Date | null) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      createdDate: date ? date.toISOString() : "",
    }));
  };

  const [pagination, setPagination] = useState<{ totalElements: number; totalPages: number }>({
    totalElements: 0,
    totalPages: 0,
  });

  const [data, setData] = useState<Account[]>([]);

  const fetchData = async () => {
    try {
      const response = await getCompanies(filters);
      console.log("Response received:", response.data);

      const newData = response.data.data.content || [];
      console.log("New data:", newData);

      setData(newData);

      setPagination({
        totalElements: response.data.data.totalElements,
        totalPages: response.data.data.totalPages,
      });

    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const accountsWithKeys = data.map((account: Account) => ({
    ...account,
    key: account.accountId,
  }));

  const handleSortChange = (field: string, order: "ASC" | "DESC") => {
    setSort({ field, order });
  };

  const fetchCompanyDetail = async (id: number) => {
    try {
      const response = await getCompanyDetail(id);
      const detail = response.data.data;

      setCompanyData({
        id: detail.contactInformation.id,
        name: detail.contactInformation.name,
        industry: detail.contactInformation.industry,
        email: detail.contactInformation.ownerName,
        phone: detail.contactInformation.phone,
        website: detail.contactInformation.website,
        rating: detail.contactInformation.rating,
        owner: detail.contactInformation.ownerUuid,
        source: detail.contactInformation.source,
        language: detail.contactInformation.language,
        description: detail.contactInformation.description || "",
        noOfEmployees: detail.contactInformation.noOfEmployees,
        street: detail.contactInformation.street,
        city: detail.contactInformation.city,
        state: detail.contactInformation.state,
        zip: detail.contactInformation.zip,
        country: detail.contactInformation.country,
        facebookLink: detail.contactInformation.facebookLink || "",
        skypeLink: detail.contactInformation.skypeLink || "",
        twitterLink: detail.contactInformation.twitterLink || "",
        linkedinLink: detail.contactInformation.linkedinLink || "",
        instagramLink: detail.contactInformation.instagramLink || "",
        whatsappLink: detail.contactInformation.whatsappLink || "",
        status: detail.contactInformation.status,
        tags: detail.tagList.map((tag: Tag) => ({
          tagId: tag.tagId,
          name: tag.name
        })),
      });
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  const applyFilters = async () => {
    try {
      const updatedFilters = { ...filters };
      setFilters(updatedFilters);

      const response = await getCompanies(updatedFilters);

      console.log("Response received:", response.data);
      setData(response.data.data.content || []);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  useEffect(() => {
    if (editCompanyId) {
      fetchCompanyDetail(editCompanyId);
    }
  }, [editCompanyId]);

  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const [editId, setEditId] = useState<number>();
  const handleUpdateCompany = async () => {
    if (!editCompanyId) return;

    try {
      await updateCompany(editCompanyId, companyData);
      setOpenEditSuccessModal(true);
      fetchData();
      setEditId(editCompanyId);
    } catch (error) {
      console.error("Error updating company:", error);
      setResponse({ status: "error", message: "Failed to update company. Please try again." });
      setShowMessageModal(true);
    }
  };

  const route = all_routes;
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    companiesData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };

  React.useEffect(() => {
    initializeStarsState();
  }, []);

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };

  const [showModalAccess, setShowModalAccess] = useState<boolean>(false);
  const [accessType, setAccessType] = useState<"public" | "private" | "isSelected">("public");
  const [selectedPeople, setSelectedPeople] = useState<any[]>([]);
  const [currentId, setCurrentId] = useState<number | null>(null);
  const [tempSelectedUsers, setTempSelectedUsers] = useState<any[]>([]);
  const handleCloseModalAccess = () => {
    setShowModalAccess(false);
    setCurrentId(null);
    setSelectedPeople([]);
    setAccessType("public");
  };

  const handleSetAccessibility = async (id: number) => {
    try {
      const response = await getAccessibilityForAccount(id);
      const accessibilityData = response.data.data;

      setCurrentId(id);

      const isPublic = accessibilityData.public;
      const isPrivate = accessibilityData.private;
      const isSelected = accessibilityData.selected;
      const selected = accessibilityData.accessMembers || [];
      const selectedIds = selected.map((member: any) => member.memberId);

      if (isPublic && selectedIds.length === 0) {
        setAccessType("public");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isPrivate && selectedIds.length === 0) {
        setAccessType("private");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isSelected) {
        setAccessType("isSelected");
        setSelectedPeople(selectedIds);
        setTempSelectedUsers(selectedIds);
      }

      setShowModalAccess(true);
    } catch (error) {
      console.error("Failed to fetch accessibility data:", error);
    }
  };
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccessType(e.target.value as "public" | "private" | "isSelected");
  };

  const handleSaveAccessibility = async () => {
    if (!currentId) return;

    let requestData;

    if (accessType === "public") {
      requestData = {
        public: true,
        selectedPeople: []
      };
    } else if (accessType === "private") {
      requestData = {
        public: false,
        selectedPeople: []
      };
    } else if (accessType === "isSelected") {
      requestData = {
        public: false,
        selectedPeople: tempSelectedUsers
      };
    }

    try {
      const response = await updateAccessibilityForAccount(currentId, requestData);
      if (response.status === 200) {
        setShowModalAccess(false);
        setResponse({ status: "success", message: "Change accessibility successfully!" });
      } else {
        setResponse({ status: "error", message: "Failed to save accessibility" });
      }
    } catch (err) {
      console.error("Error saving accessibility:", err);
    } finally {
      setShowMessageModal(true);
    }
  };
  const [selectedOwnerUuid, setSelectedOwnerUuid] = useState<string>();
  const [showChangeOwnerModal, setShowChangeOwnerModal] = useState(false);
  const handleChangeOwner = async () => {
    try {
      if (selectedRecordIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead" });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }
      const response = await changeOwner(selectedRecordIds, selectedOwnerUuid);
      console.log("Change Owner:", response.data);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Change Owner successfully!" });
        setSelectedRecordIds([]);
        setSelectedOwnerUuid("");
        setShowChangeOwnerModal(false);
      }
    } catch (error) {
      console.error("Error change owner", error);
      setResponse({ status: "error", message: "Failed to change owner. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };
  const columns = [
    {
      title: "Company Name",
      dataIndex: "name",
      render: (text: string, record: Account) => (
        <h2 className="d-flex align-items-center">
          <Link to={`/crm/company-details/${record.accountId}`} className="title-name">
            {text}
          </Link>
        </h2>
      ),
      sorter: (a: Account, b: Account) => a.name.localeCompare(b.name),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: Account, b: Account) => a.phone.localeCompare(b.phone),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      sorter: (a: Account, b: Account) => a.rating - b.rating,
      render: (rating: number) => {
        const ratingMap: Record<number, { text: string; color: string }> = {
          1: { text: "Cold", color: "#00BFFF" },
          2: { text: "Warm", color: "#32CD32" },
          3: { text: "Hot", color: "#FF4500" },
        };

        const { text, color } = ratingMap[rating] || { text: "N/A", color: "#999" };

        return (
          <span style={{ color, fontWeight: 600 }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a: Account, b: Account) => a.location.localeCompare(b.location),
    },
    {
      title: "Owner",
      dataIndex: "ownerName",
      sorter: (a: Account, b: Account) => a.ownerName.localeCompare(b.ownerName),
    },
    {
      title: "Action",
      render: (_: any, record: Account) => (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_edit"
              onClick={() => {
                setEditCompanyId(record.accountId);
                fetchCompanyDetail(record.accountId);
              }}
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_account"
              onClick={() => setDeleteCompanyId(record.accountId)}
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              onClick={() =>
                record.accountId &&
                handleSetAccessibility(record.accountId)
              }
            >
              <i className="ti ti-lock-open text-warning"></i> Set Accessibility
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Companies<span className="count-title">{data.length}</span>
                    </h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card ">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                          onClick={() =>
                            setCompanyData({
                              id: 0,
                              name: "",
                              industry: "",
                              email: "",
                              phone: "",
                              website: "",
                              rating: 0,
                              owner: "",
                              source: "",
                              language: "",
                              description: "",
                              noOfEmployees: 0,
                              street: "",
                              city: "",
                              state: "",
                              zip: "",
                              country: "",
                              facebookLink: "",
                              skypeLink: "",
                              twitterLink: "",
                              linkedinLink: "",
                              instagramLink: "",
                              whatsappLink: "",
                              status: "ACTIVE",
                              tags: [],
                            })
                          }
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Company
                        </Link>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Filter & Sort */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    {/* Sort Dropdown */}
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                    </div>
                    {/* Filter Button */}
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="btn btn-primary ms-2"
                          onClick={() => setShowChangeOwnerModal(true)}
                        >
                          <i className="ti ti-user" />
                          Change Owner
                        </Link>
                      </div>
                      <div className="form-sorts dropdown me-2 ms-auto">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              {/* Country */}
                              <div className="filter-set-content mb-2">
                                <div className="filter-set-content-head">
                                  <Link to="#" data-bs-toggle="collapse" data-bs-target="#country">
                                    Country
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse show" id="country">
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="country"
                                      value={filters.country}
                                      onChange={handleFilterChange}
                                      placeholder="Enter country"
                                    />
                                  </div>
                                </div>
                              </div>


                              {/* Rating Min & Max */}
                              <div className="filter-set-content mb-2">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#rating">
                                    Rating
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="rating">
                                  <div className="filter-content-list d-flex">
                                    <input
                                      type="number"
                                      className="form-control me-2"
                                      name="startRating"
                                      value={filters.startRating || ""}
                                      onChange={handleFilterChange}
                                      placeholder="Min"
                                    />
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="endRating"
                                      value={filters.endRating || ""}
                                      onChange={handleFilterChange}
                                      placeholder="Max"
                                    />
                                  </div>
                                </div>
                              </div>


                              {/* Owner */}
                              <div className="filter-set-content mb-2">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#owner">
                                    Owner
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="owner">
                                  <div className="filter-content-list">
                                    <Select
                                      options={ownerOptions}
                                      isMulti
                                      onChange={handleOwnerChange}
                                      placeholder="Search & Select Owners"
                                    />
                                  </div>
                                </div>
                              </div>


                              {/* Tag IDs */}
                              <div className="filter-set-content mb-2">
                                <div className="filter-set-content-head">
                                  <Link to="#" className="collapsed" data-bs-toggle="collapse" data-bs-target="#tagIds">
                                    Tags
                                  </Link>
                                </div>
                                <div className="filter-set-contents accordion-collapse collapse" id="tagIds">
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="tagIds"
                                      value={filters.tagIds}
                                      onChange={handleFilterChange}
                                      placeholder="Enter tag IDs"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-md-6">
                                  <Link to="#" className="btn btn-light" onClick={() => setFilters(initialFilterState)}>
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-md-6 text-end">
                                  <Link to="#" className="btn btn-primary" onClick={applyFilters}>
                                    Apply Filter
                                  </Link>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      {/* View Icons */}
                      <div className="view-icons">
                        <Link to={route.companies} className="active">
                          <i className="ti ti-list-tree" />
                        </Link>
                        <Link to='{route.companiesKanban}'>
                          <i className="ti ti-grid-dots" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Table */}
                  <div className="table-responsive custom-table mt-3">
                    <Table dataSource={accountsWithKeys} columns={columns} rowSelection={rowSelection} />
                  </div>
                </div>
                {/* Filter */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="delete_account" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Companies?</h4>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button className="btn btn-danger" data-bs-dismiss="modal" onClick={handleDeleteCompany}>
                    Yes, Delete it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Company */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add Company</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">

                      {/* Company Name */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Company Name<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={companyData.name}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="email"
                            className="form-control"
                            value={companyData.email}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.email && <small className="text-danger">{errorsAddForm.email}</small>}
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="phone"
                            className="form-control"
                            value={companyData.phone}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.phone && <small className="text-danger">{errorsAddForm.phone}</small>}
                        </div>
                      </div>

                      {/* Website */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Website <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="website"
                            className="form-control"
                            value={companyData.website}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.website && <small className="text-danger">{errorsAddForm.website}</small>}
                        </div>
                      </div>

                      {/* Status */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Status</label>
                          <Select
                            classNamePrefix="react-select"
                            options={statusOption}
                            placeholder="Select status"
                            value={statusOption.find(option => option.value === companyData.status)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "status")
                            }
                          />
                        </div>
                      </div>

                      {/* Rating */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Rating</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <Select
                              className="select2"
                              options={ratingOptions}
                              classNamePrefix="react-select"
                              placeholder="Select rating"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "rating")
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* Tags */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Tags</label>
                          <Select
                            isMulti
                            options={allTags.map(tag => ({
                              value: tag.id,
                              label: tag.name
                            }))}
                            placeholder="Select tags"
                            classNamePrefix="react-select"
                            value={companyData.tags.map(tag => ({
                              value: tag.tagId,
                              label: tag.name
                            }))}
                            onChange={(selectedOptions) => {
                              setCompanyData(prev => ({
                                ...prev,
                                tags: selectedOptions ? selectedOptions.map(option => ({
                                  tagId: option.value,
                                  name: option.label
                                })) : []
                              }));
                            }}
                          />
                        </div>
                      </div>

                      {/* Owner */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Owner</label>
                          <input
                            type="text"
                            className="form-control"
                            name="owner"
                            value={companyData.owner}
                            onChange={handleInputChange}
                            disabled
                            placeholder="Current user"
                          />
                        </div>
                      </div>

                      {/* Source */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Source</label>
                          <Select
                            classNamePrefix="react-select"
                            options={optionsource}
                            placeholder="Select source"
                            value={optionsource.find(option => option.value === companyData.source)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "source")
                            }
                          />
                        </div>
                      </div>

                      {/* Language */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Language</label>
                          <Select
                            classNamePrefix="react-select"
                            options={languageOptions}
                            placeholder="Select language"
                            value={languageOptions.find(option => option.value === companyData.language)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "language")
                            }
                          />
                        </div>
                      </div>

                      {/* No. of Employees */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">No. of Employees</label>
                          <input
                            type="number"
                            name="noOfEmployees"
                            className="form-control"
                            value={companyData.noOfEmployees}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Industry */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Industry</label>
                          <Select
                            classNamePrefix="react-select"
                            options={optionindustry}
                            placeholder="Select industry"
                            value={optionindustry.find(option => option.value === companyData.industry)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "industry")
                            }
                          />
                        </div>
                      </div>

                      {/* Description */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Description</label>
                          <textarea
                            name="description"
                            className="form-control"
                            rows={4}
                            value={companyData.description}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}

              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Street Address</label>
                          <input
                            type="text"
                            name="street"
                            className="form-control"
                            value={companyData.street}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.street && <small className="text-danger">{errorsAddForm.street}</small>}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Country</label>
                          <input
                            type="text"
                            name="country"
                            className="form-control"
                            value={companyData.country}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.country && <small className="text-danger">{errorsAddForm.country}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">State / Province</label>
                          <input
                            type="text"
                            name="state"
                            className="form-control"
                            value={companyData.state}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.state && <small className="text-danger">{errorsAddForm.state}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City</label>
                          <input
                            type="text"
                            name="city"
                            className="form-control"
                            value={companyData.city}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.city && <small className="text-danger">{errorsAddForm.city}</small>}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode</label>
                          <input
                            type="text"
                            name="zip"
                            className="form-control"
                            value={companyData.zip}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.zip && <small className="text-danger">{errorsAddForm.zip}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}

              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input
                            type="text"
                            name="facebookLink"
                            className="form-control"
                            value={companyData.facebookLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.facebookLink && <small className="text-danger">{errorsAddForm.facebookLink}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype</label>
                          <input
                            type="text"
                            name="skypeLink"
                            className="form-control"
                            value={companyData.skypeLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.skypeLink && <small className="text-danger">{errorsAddForm.skypeLink}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin</label>
                          <input
                            type="text"
                            name="linkedinLink"
                            className="form-control"
                            value={companyData.linkedinLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.linkedinLink && <small className="text-danger">{errorsAddForm.linkedinLink}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input
                            type="text"
                            name="twitterLink"
                            className="form-control"
                            value={companyData.twitterLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.twitterLink && <small className="text-danger">{errorsAddForm.twitterLink}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input
                            type="text"
                            name="whatsappLink"
                            className="form-control"
                            value={companyData.whatsappLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.whatsappLink && <small className="text-danger">{errorsAddForm.whatsappLink}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input
                            type="text"
                            name="instagramLink"
                            className="form-control"
                            value={companyData.instagramLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.instagramLink && <small className="text-danger">{errorsAddForm.instagramLink}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddCompany}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add Company */}
      {/* Edit Company */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Company</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">

                      {/* Company Name */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Company Name</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={companyData.name}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="email"
                            className="form-control"
                            value={companyData.email}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.email && <small className="text-danger">{errorsAddForm.email}</small>}
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="phone"
                            className="form-control"
                            value={companyData.phone}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.phone && <small className="text-danger">{errorsAddForm.phone}</small>}
                        </div>
                      </div>

                      {/* Website */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Website <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="website"
                            className="form-control"
                            value={companyData.website}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.website && <small className="text-danger">{errorsAddForm.website}</small>}
                        </div>
                      </div>

                      {/* Status */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Status</label>
                          <Select
                            classNamePrefix="react-select"
                            options={statusOption}
                            placeholder="Select status"
                            value={statusOption.find(option => option.value === companyData.status)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "status")
                            }
                          />
                        </div>
                      </div>

                      {/* Rating */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Ratings</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <Select
                              className="select2"
                              options={ratingOptions}
                              classNamePrefix="react-select"
                              value={ratingOptions.find(
                                (option) => Number(option.value) === companyData?.rating
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "rating")
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* Tags */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Tags</label>
                          <Select
                            isMulti
                            options={allTags.map(tag => ({
                              value: tag.id,
                              label: tag.name
                            }))}
                            placeholder="Select tags"
                            classNamePrefix="react-select"
                            value={companyData.tags.map(tag => ({
                              value: tag.tagId,
                              label: tag.name
                            }))}
                            onChange={(selectedOptions) => {
                              setCompanyData(prev => ({
                                ...prev,
                                tags: selectedOptions ? selectedOptions.map(option => ({
                                  tagId: option.value,
                                  name: option.label
                                })) : []
                              }));
                            }}
                          />
                        </div>
                      </div>

                      {/* Owner */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Owner</label><span className="text-danger">*</span>
                          <Select
                            className="select2"
                            options={ownerOptions}
                            classNamePrefix="react-select"
                            value={selectedOwners}
                            onChange={(selectedOption) => {
                              setSelectedOwners(selectedOption ? [selectedOption] : []);

                              setCompanyData((prevState) => {
                                return {
                                  ...prevState,
                                  owner: selectedOption?.value || "",
                                  id: prevState.id ?? 0,
                                };
                              });
                            }}
                            placeholder="Select Owner"
                          />
                          {errorsAddForm.owner && <small className="text-danger">{errorsAddForm.owner}</small>}
                        </div>
                      </div>

                      {/* Source */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Source</label>
                          <Select
                            classNamePrefix="react-select"
                            options={optionsource}
                            placeholder="Select source"
                            value={optionsource.find(option => option.value === companyData.source)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "source")
                            }
                          />
                        </div>
                      </div>

                      {/* Language */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Language</label>
                          <Select
                            classNamePrefix="react-select"
                            options={languageOptions}
                            placeholder="Select language"
                            value={languageOptions.find(option => option.value === companyData.language)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "language")
                            }
                          />
                        </div>
                      </div>

                      {/* No. of Employees */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">No. of Employees</label>
                          <input
                            type="number"
                            name="noOfEmployees"
                            className="form-control"
                            value={companyData.noOfEmployees}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Industry */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Industry</label>
                          <Select
                            classNamePrefix="react-select"
                            options={optionindustry}
                            placeholder="Select industry"
                            value={optionindustry.find(option => option.value === companyData.industry)}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "industry")
                            }
                          />
                        </div>
                      </div>

                      {/* Description */}
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Description</label>
                          <textarea
                            name="description"
                            className="form-control"
                            rows={4}
                            value={companyData.description}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}

              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Street Address</label>
                          <input
                            type="text"
                            name="street"
                            className="form-control"
                            value={companyData?.street || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Country</label>
                          <input
                            type="text"
                            name="country"
                            className="form-control"
                            value={companyData?.country || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">State / Province</label>
                          <input
                            type="text"
                            name="state"
                            className="form-control"
                            value={companyData.state || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City</label>
                          <input
                            type="text"
                            name="city"
                            className="form-control"
                            value={companyData.city || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode</label>
                          <input
                            type="text"
                            name="zip"
                            className="form-control"
                            value={companyData.zip || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}


              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input
                            type="text"
                            name="facebookLink"
                            className="form-control"
                            value={companyData?.facebookLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype</label>
                          <input
                            type="text"
                            name="skypeLink"
                            className="form-control"
                            value={companyData?.skypeLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin</label>
                          <input
                            type="text"
                            name="linkedinLink"
                            className="form-control"
                            value={companyData?.linkedinLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input
                            type="text"
                            name="twitterLink"
                            className="form-control"
                            value={companyData?.twitterLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input
                            type="text"
                            name="whatsappLink"
                            className="form-control"
                            value={companyData?.whatsappLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input
                            type="text"
                            name="instagramLink"
                            className="form-control"
                            value={companyData?.instagramLink || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.name && <small className="text-danger">{errorsAddForm.name}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpdateCompany}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Company */}
      {/* Create Company Noti */}
      <Modal show={openModal} onHide={() => { setOpenModal(false); window.location.reload(); }}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Company Created Successfully!!!</h3>
            <div className="row g-2 mt-3">
              <div className="col-md-6">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setOpenModal(false);
                    window.location.reload();
                  }}
                >
                  Cancel
                </button>

              </div>
              <div className="col-md-6">
                <Link
                  to={`/crm/company-details/${createdId}`}
                  onClick={() => setOpenModal(false)}
                  className="btn btn-primary w-100"
                >
                  Ok
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* Edit Lead Success Modal */}
      <Modal show={openEditSuccessModal} onHide={() => { setOpenEditSuccessModal(false); window.location.reload(); }}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Company Edited Successfully!!!</h3>
            <div className="row g-2 mt-3">
              <div className="col-md-6">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setOpenEditSuccessModal(false);
                    window.location.reload();
                  }}
                >
                  Cancel
                </button>
              </div>
              <div className="col-md-6">
                <Link
                  to={`/crm/company-details/${editId}`}
                  onClick={() => {
                    setOpenEditSuccessModal(false);
                  }}
                  className="btn btn-primary w-100"
                >
                  Ok
                </Link>
              </div>
            </div>

          </div>
        </div>
      </Modal>
      {/* Access Modal */}
      <Modal show={showModalAccess} onHide={handleCloseModalAccess} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Set Accessibility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Radio buttons */}
            <Form.Check
              type="radio"
              label="Public"
              value="public"
              name="access"
              checked={accessType === "public"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Private"
              value="private"
              name="access"
              checked={accessType === "private"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Selected People"
              value="isSelected"
              name="access"
              checked={accessType === "isSelected"}
              onChange={() => {
                setAccessType("isSelected");
                setTempSelectedUsers(selectedPeople);
              }}
            />

            {accessType === "isSelected" && (
              <>
                <div className="mb-3 mt-3">
                  <label className="col-form-label">Select Users</label>
                  <Select
                    isMulti
                    name="users"
                    options={users.map(user => ({
                      value: user.id,
                      label: `${user.username} - ${user.role}`
                    }))}
                    value={users
                      .filter(user => tempSelectedUsers.includes(user.id))
                      .map(user => ({
                        value: user.id,
                        label: `${user.username} - ${user.role}`
                      }))}
                    onChange={(selectedOptions) => {
                      setTempSelectedUsers(selectedOptions.map(opt => opt.value));
                    }}
                    isSearchable={true}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        maxWidth: '100%',
                        overflow: 'hidden'
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        whiteSpace: 'nowrap'
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        maxWidth: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      })
                    }}
                  />
                </div>

                {tempSelectedUsers.length > 0 && (
                  <div className="mt-2 p-2 border rounded bg-light">
                    <strong>Selected Users:</strong>
                    <ul className="mb-0 ps-3">
                      {tempSelectedUsers.map(userId => {
                        const user = users.find(u => u.id === userId);
                        return user ? (
                          <li key={user.id}>
                            {user.username} - {user.role}
                          </li>
                        ) : null;
                      })}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalAccess}>
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            setSelectedPeople(tempSelectedUsers);
            handleSaveAccessibility();
          }}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      {/*Change Owner Modal */}
      {showChangeOwnerModal && (
        <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Owner</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowChangeOwnerModal(false)}
                  aria-label="Close"
                ><i className="ti ti-x" /></button>
              </div>

              <div className="modal-body">
                <Select
                  className="select2"
                  options={ownerOptions}
                  classNamePrefix="react-select"
                  value={ownerOptions.find((option) => option.value === selectedOwnerUuid) || null}
                  onChange={(selectedOption) => {
                    setSelectedOwnerUuid(selectedOption?.value);
                  }}
                  placeholder="Select Owner"
                />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => setShowChangeOwnerModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleChangeOwner}>Change</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </>
  );
};

export default Companies;
